export const NumericizeObjectProperties = (objectWithStrings) => {
    const objectWithNumbers = {};

    Object.getOwnPropertyNames(objectWithStrings).forEach(prop => {
        if (objectWithStrings[prop] && !isNaN(objectWithStrings[prop]) && (typeof objectWithStrings[prop] !== 'boolean')) {
            objectWithNumbers[prop] = Number(objectWithStrings[prop]);
        }
        else {
            objectWithNumbers[prop] = objectWithStrings[prop];
        }
    });

    return objectWithNumbers;
};

const Helper = () => {

    const months = [{ value: "0", text: "Select a Fiscal Year End" },
    { value: "1", text: "1 - January" },
    { value: "2", text: "2 - February" },
    { value: "3", text: "3 - March" },
    { value: "4", text: "4 - April" },
    { value: "5", text: "5 - May" },
    { value: "6", text: "6 - June" },
    { value: "7", text: "7 - July" },
    { value: "8", text: "8 - August" },
    { value: "9", text: "9 - September" },
    { value: "10", text: "10 - October" },
    { value: "11", text: "11 - November" },
    { value: "12", text: "12 - December" }];

    const leaseTypes = [{ value: "", text: "Select a Leasing Type" },
    { value: "0", text: "0 - Removed" },
    { value: "1", text: "1 - Owned" },
    { value: "2", text: "2 - Managed" },
    { value: "3", text: "3 - Joint Venture" },
    { value: "4", text: "4 - Owned New" },
    { value: "5", text: "5 - Joint Venture New" },
    { value: "8", text: "8 - New Managed" }
        //{ value: "10", text: "10 - Kentucky" }
    ];

    const systems = [
        { value: "E", text: "E - eSite", name: "eSite" },
        { value: "Y", text: "Y - Yardi", name: "Yardi" },
        { value: "N", text: "N - Entrata", name: "Entrata" },
        { value: "R", text: "R - Realpage", name: "Realpage" }
    ];

    const getPMSystem = (pmSystem) => {
        var name = systems.find(pm => pm.value === pmSystem).name;
        return name;
    };

    const comTypes = [
        { value: "S", text: "S - Student" },
        { value: "M", text: "M - Multi-Family" }
    ];

    const leaseByTypes = [
        { value: "0", text: "Beds" },
        { value: "1", text: "Units" }
    ];

    const investmentManagerTypes = [
        { value: "local", text: "Local Asset Manager" },
        { value: "regional", text: "Regional Asset Manager" },
        { value: "investment", text: "Regional Investment Manager" }
    ];

    const onCampusOptions = [
        { value: "1", text: "Yes" },
        { value: "0", text: "No" }
    ];

    const resources = [{ value: "Companies", text: "Companies", url: "/companies", access: "Companies" },
    { value: "Regionals", text: "Regionals", url: "/regionals", access: "Regionals", indent: true },
    { value: "SMA", text: "Sales / Marketing Associates", url: "/sales-marketing-associates", access: "SMA", indent: true },
    { value: "Investment Managers", text: "Investment Managers", url: "/investment-managers", access: "Investment Managers", indent: true },
    { value: "Clients", text: "Clients", url: "/clients", access: "Clients" },
    { value: "Bed Types", text: "Bed Types", url: "/bed-types", access: "Bed Types" },
    { value: "Global Variables", text: "Global Variables", url: "/globals", access: "Global Variables" },
    { value: "Users", text: "Users", url: "/users", access: "Users" }
    ];

    return {
        Months: months,
        LeaseTypes: leaseTypes,
        PropertyManagementSystems: systems,
        GetPMSystem: getPMSystem,
        CommunityTypes: comTypes,
        LeaseByTypes: leaseByTypes,
        Roles: userRoles,
        OnCampus: onCampusOptions,
        Resources: resources,
        InvestmentManagerTypes: investmentManagerTypes
    };
};

export default Helper;

export const GetOptionText = (options, value, field = 'value') => {
    const option = options.filter(opt => opt[field] === value);

    if (option.length > 0) {
        return option[0].text;
    }
    else {
        return value;
    }
};

export const FormatDate = (date, friendly = false) => {
    var d = new Date(new Date(date).toLocaleDateString('en-US', { timeZone: 'UTC' })),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2 && !friendly)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    if (friendly) {
        return [month, day, year].join('/');
    }
    else {
        return [year, month, day].join('-');
    }
}

export const FormatTime = (date, zone = false) => {
    var d = new Date(date),
        hours = '' + d.getUTCHours(),
        minutes = '' + d.getUTCMinutes(),
        seconds = d.getUTCSeconds(),
        meridian = d.getUTCHours() >= 12 ? ' PM' : ' AM';

    // convert to 12 hour
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour 0 should be 12

    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    if (zone) {
        return [hours, minutes, seconds].join(':') + meridian + ' GMT';
    }
    else {
        return [hours, minutes, seconds].join(':') + meridian;
    }
}

export const FuzzyDate = (date, fuzzy = true) => {
    const dateFormat = require('dateformat');
    const unformatted = new Date(date);
    let day = dateFormat(date, "m/d/yy");
    let time = `at ${dateFormat(date, "h:MM TT")}`;
    let today = new Date();
    if (fuzzy) {
        if (unformatted.getDate() === today.getDate()) { // Today
            day = 'Today';
        }
        else if (unformatted.getDate() === today.getDate() - 1) { // Yesterday
            day = 'Yesterday';
        }
    }

    //if (day === 'Today') {
    //    console.log('now', today.getHours());
    //    console.log('passed date hours', unformatted.getHours());
    //    console.log('now - 1 hour', (today.getHours() - 1));
    //    console.log('now - 2 hour', (today.getHours() - 2));
    //    if ((today.getHours() - 2) < unformatted.getHours() && unformatted.getHours() <= (today.getHours() - 1)) {
    //        return `About an hour ago`;
    //    }
    //    else if ((today.getHours() - 12) <= unformatted.getHours() && unformatted.getHours() <= (today.getHours() - 2)) {
    //        time = `${Math.ceil(Math.abs(today - unformatted) / (1000 * 60 * 60))} hours ago`;
    //    }
    //}
    return `${day} ${time}`;
};

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

export const getUnitCounts = (response) => {
    const floorPlans = response.result.PhysicalProperty.Property[0].ILS_Unit.reduce((fps, unit) => {
        const unitType = unit.Units.Unit.UnitType;
        const record = fps.filter(fp => fp.floorPlanName === unitType)[0];

        if (record) {
            record.dbdesignBeds++;
        }
        else {
            const unitMix = `${unit.Units.Unit.UnitBedrooms}X${unit.Units.Unit.UnitBathrooms}`;
            fps.push({
                id: unit.Units.Unit["@attributes"].FloorPlanId,
                dbunitType: unit.Units.Unit.UnitType.indexOf(unitMix) === -1 ? `${unitMix}${unit.Units.Unit.UnitType}` : unit.Units.Unit.UnitType,
                floorPlanName: unit.Units.Unit.UnitType,
                dbdesignBeds: 1,
                unitMix
            });
        }

        return fps;
    }, []);

    return floorPlans;
};

export const formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4}).*?$/);
    if (match) {
        var intlCode = (match[1] ? '+1 ' : '');
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
}

export const userRoles = [
    { value: "user", text: "User" },
    { value: "admin", text: "Admin" }
];


// WEBPACK FOOTER //
// ./src/Helpers/Helper.js